import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../config";
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleReset = async (e) => {
    e.preventDefault();

    const res = await fetch(`${BASE_URL}/api/reset_password.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        newPassword: newPassword,
      }),
    });

    const data = await res.json();

    if (data.status === "success") {
      alert("Password updated successfully ✅");

      // 🔁 Redirect to login page
      navigate("/gruhlaxmiMyAdmin/login");
    } else {
      alert(data.message);
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-box">
        <h2> Reset Password</h2>

        <form onSubmit={handleReset}>
          <input
            type="email"
            placeholder="Enter Email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter New Password"
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />

            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i
                className={`bi ${
                  showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"
                }`}
              ></i>
            </span>
          </div>

          <button type="submit">Update Password</button>
        </form>

        <a href="/gruhlaxmiMyAdmin/login" className="back-login">
          <i className="bi bi-box-arrow-in-left"></i> Back to Login
        </a>
      </div>
    </div>
  );
}
